// extracted by mini-css-extract-plugin
module.exports = {"buttonWrap":"inviteFacilitatorsFieldArray_buttonWrap__3qiYa","body":"inviteFacilitatorsFieldArray_body__2M13g"};